import { gql } from 'graphql-request'

export const GET_STORY_FOR_SHARE = gql`
  query GetBookForShare($getBookReaderId: Int!) {
    getBookReader(id: $getBookReaderId) {
      id
      coverImgPath
      title
      cover
      penName {
        firstPenName
      }
      category {
        name
      }
      tags {
        name
      }
      facebookShareImageUrl
      twitterShareImageUrl
    }
  }
`

export const GET_STORY_FOR_SHARE_BYPASS = gql`
  query GetBookForShare($getBookReaderId: Int!, $bypassAuth: Boolean) {
    getBookReader(id: $getBookReaderId, bypassAuth: $bypassAuth) {
      id
      coverImgPath
      title
      cover
      penName {
        firstPenName
      }
      category {
        name
      }
      tags {
        name
      }
      facebookShareImageUrl
      twitterShareImageUrl
    }
  }
`